
import { supabase } from '@/integrations/supabase/client';
import { Farm } from '@/types/database.types';

/**
 * Upload farms to the database
 * @param farms Array of farm objects
 * @returns Promise with upload result
 */
export const uploadFarmsToDatabase = async (farms: Partial<Farm>[]) => {
  try {
    // Ensure all required fields are present in each farm
    const validFarms = farms.filter(farm => 
      farm.land_size !== undefined && 
      farm.phone_number !== undefined && 
      farm.region !== undefined
    );
    
    if (validFarms.length === 0) {
      throw new Error('No valid farms to upload: missing required fields');
    }
    
    // Make TypeScript happy by explicitly creating objects with required fields
    const preparedFarms = validFarms.map(farm => ({
      land_size: farm.land_size as number,
      phone_number: farm.phone_number as string,
      region: farm.region as string,
      farmer_name: farm.farmer_name || '',
      // Include any other properties from the farm object
      ...farm
    }));
    
    const { data, error } = await supabase
      .from('farms')
      .insert(preparedFarms)
      .select();
    
    if (error) throw error;
    
    return { success: true, count: data.length, data };
  } catch (error) {
    console.error('Error uploading farms:', error);
    throw error;
  }
};
